export enum AutopilotReferenceEnum {
    AP_UNKNOWN,
	/**
	 * Pixhawk autopilots.
	 */
	AP_PIXHAWK,
	/**
	 * DJI autopilots.
	 */
	AP_DJI,
	/**
	 * APK Relay of DJI autopilots.
	 */
	RELAY_DJI_APK,
	/**
	 * HUB Relay of DJI autopilots.
	 */
	RELAY_DJI_HUB,
	/**
	 * Relay of Pixhawk autopilots.
	 */
	RELAY_PIXHAWK
}